import React from 'react';
import {
  PAYMENT_METHOD_OPTS,
  fmt,
  formatAmountInput,
  parseAmountInput,
} from './RevenueEventModal.helpers';
import {
  mobileAmountInput,
  mobileCard,
  mobileCardHead,
  mobileCardName,
  mobileCardSub,
  mobileCardTitle,
  mobileDangerBtn,
  mobileFieldLabel,
  mobileFieldWrap,
  mobileFull,
  mobileInput,
  mobilePaymentGrid,
} from './RevenueEventModal.mobileStyles';

function MobileField({ label, value, onChange, type = 'text', options, amount }) {
  return (
    <label style={mobileFieldWrap}>
      <span style={mobileFieldLabel}>{label}</span>
      {options ? (
        <select value={value ?? ''} onChange={(e) => onChange(e.target.value || null)} style={mobileInput}>
          <option value="">선택</option>
          {options.map((option) => <option key={option.value ?? option} value={option.value ?? option}>{option.label ?? option}</option>)}
        </select>
      ) : (
        <input
          type={amount ? 'text' : type}
          inputMode={amount ? 'text' : undefined}
          pattern={amount ? '-?[0-9,]*' : undefined}
          value={amount ? formatAmountInput(value) : (value ?? '')}
          onFocus={(e) => { if (amount) e.target.select(); }}
          onChange={(e) => onChange(amount ? parseAmountInput(e.target.value) : (e.target.value || null))}
          style={amount ? mobileAmountInput : mobileInput}
        />
      )}
    </label>
  );
}

export function MobilePaymentCard({ payment, index, onChange, onRemove }) {
  return (
    <div style={mobileCard}>
      <div style={mobileCardHead}>
        <div style={mobileCardTitle}>
          <span style={mobileCardName}>{fmt(payment.amount)}</span>
          <span style={mobileCardSub}>{payment.payment_date || '지불일 없음'}</span>
        </div>
        <button type="button" style={mobileDangerBtn} onClick={() => onRemove(index)}>삭제</button>
      </div>
      <div style={mobilePaymentGrid}>
        <MobileField label="지불일" type="date" value={payment.payment_date} onChange={(value) => onChange(index, 'payment_date', value)} />
        <MobileField label="금액" amount value={payment.amount} onChange={(value) => onChange(index, 'amount', value)} />
        <MobileField label="지불수단" value={payment.payment_method} onChange={(value) => onChange(index, 'payment_method', value)} options={PAYMENT_METHOD_OPTS} />
        {payment.payment_method === 'cash' ? (
          <>
            <MobileField label="현금영수증번호" value={payment.cash_receipt_issue_no} onChange={(value) => onChange(index, 'cash_receipt_issue_no', value)} />
            <MobileField label="현금영수증금액" amount value={payment.cash_receipt_amount} onChange={(value) => onChange(index, 'cash_receipt_amount', value)} />
          </>
        ) : (
          <div style={mobileFull}><MobileField label="카드입금 메모" value={payment.card_deposit_memo} onChange={(value) => onChange(index, 'card_deposit_memo', value)} /></div>
        )}
      </div>
    </div>
  );
}

export function MobileRefundCard({ refund, index, onChange, onRemove }) {
  return (
    <div style={mobileCard}>
      <div style={mobileCardHead}>
        <div style={mobileCardTitle}>
          <span style={mobileCardName}>{fmt(refund.amount)}</span>
          <span style={mobileCardSub}>{refund.refund_date || '환불일 없음'}</span>
        </div>
        <button type="button" style={mobileDangerBtn} onClick={() => onRemove(index)}>삭제</button>
      </div>
      <div style={mobilePaymentGrid}>
        <MobileField label="환불일" type="date" value={refund.refund_date} onChange={(value) => onChange(index, 'refund_date', value)} />
        <MobileField label="금액" amount value={refund.amount} onChange={(value) => onChange(index, 'amount', value)} />
        <MobileField label="환불수단" value={refund.refund_method} onChange={(value) => onChange(index, 'refund_method', value)} options={PAYMENT_METHOD_OPTS} />
        {refund.refund_method === 'cash' ? (
          <>
            <MobileField label="현영 취소승인번호" value={refund.cash_receipt_cancel_approval_no} onChange={(value) => onChange(index, 'cash_receipt_cancel_approval_no', value)} />
            <MobileField label="현영 취소금액" amount value={refund.cash_receipt_cancel_amount} onChange={(value) => onChange(index, 'cash_receipt_cancel_amount', value)} />
          </>
        ) : (
          <MobileField label="카드취소/메모" value={refund.memo} onChange={(value) => onChange(index, 'memo', value)} />
        )}
        <div style={mobileFull}>
          <MobileField label="환불계좌/메모" value={refund.refund_account} onChange={(value) => onChange(index, 'refund_account', value)} />
        </div>
      </div>
    </div>
  );
}
